<el-dropdown class="relative">
  <button class="relative block text-gray-400 hover:text-white">
    <span class="absolute -inset-2.5"></span>
    <span class="sr-only">Menü öffnen</span>
    <svg aria-hidden="true" class="size-5 text-gray-900" data-slot="icon" viewBox="0 0 20 20">
      <path
        d="M3 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8.5 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM15.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>
    </svg>
  </button>
  <el-menu #dropdown anchor="bottom end" class="themed-dropdown" popover>
    <ng-content></ng-content>
  </el-menu>
</el-dropdown>
